
/**
 * Copyright (c) 2018 Microsoft Corporation
 * Modules Registration
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

/**
 * Register all available modules
 */
export const registerAllModules = (requiredModules) => {
    let binding = { modules: {}, dataActions: {} };
    const { log, error }  = console;
    const detailedWebpackError = (msg, errorObject) => { error(msg); error(errorObject); process.env.NODE_ENV !== 'development' && error('Run in dev mode to see full list of errors'); process.exit(50); }
    const handleError = (modPath, errObject) => {
        detailedWebpackError('Error with path: ' + modPath, errObject);
    }
    if (requiredModules) {
        requiredModules = requiredModules.map((module) => module.toLowerCase());
    }
    const isNotRegistered = (moduleName) => {
        return !requiredModules || requiredModules.length <= 0 || requiredModules.findIndex((module) => module === moduleName) !== -1;
    };

    
    const registerActionId = (actionPath) => {
        if (binding.dataActions[actionPath] &&
            binding.dataActions[actionPath].default &&
            binding.dataActions[actionPath].default.prototype &&
            binding.dataActions[actionPath].default.prototype.id) {
            binding.dataActions[binding.dataActions[actionPath].default.prototype.id] = binding.dataActions[actionPath];
        } else {
            Object.keys(binding.dataActions[actionPath] || {}).forEach(exportName => {
                if (binding.dataActions[actionPath][exportName] &&
                    binding.dataActions[actionPath][exportName].prototype &&
                    binding.dataActions[actionPath][exportName].prototype.Action) {
                    binding.dataActions[binding.dataActions[actionPath][exportName].prototype.id] = binding.dataActions[actionPath][exportName];
                }
            })
        }
    };

    const registerSanitizedActionPath = (sanitizedActionPath, dataAction) => {
        if (process.env.NODE_ENV === 'development') {
            if (!dataAction.default) {
                throw new Error('Data action path does not have a default export');
            }
            if (!(dataAction.default.prototype.id && binding.dataActions[dataAction.default.prototype.id]) || !binding.dataActions[sanitizedActionPath]) {
                binding.dataActions[sanitizedActionPath] = dataAction;
            }
        } else {
            binding.dataActions[sanitizedActionPath] = dataAction;
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
    };
    
    try {


    isNotRegistered('default-page-summary') && (binding.modules['default-page-summary'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-default-page-summary' */
            'partner/modules/lds-default-summary/default-page-summary.tsx'),
        $type: 'htmlHeadTagsModule',
        da: [{name:'countries',  path:'actions/get-country.action', runOn: 0},{name:'pageSummary',  path:'modules/lds-default-summary/default-page-summary.action', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'default-page-summary',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/lds-default-summary'
    });
        

    isNotRegistered('fabrikam') && (binding.modules['fabrikam'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-fabrikam' */
            'partner/themes/fabrikam/fabrikam.tsx'),
        $type: 'themeModule',
        da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', moduleName: 'content-block',runOn: 0},{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', moduleName: 'order-details',runOn: 0},{name:'countries',  path:'actions/get-country.action', moduleName: 'header',runOn: 1},{name:'languages',  path:'actions/get-language.action', moduleName: 'header',runOn: 1},{name:'policy',  path:'actions/get-policy.action', moduleName: 'footer-category',runOn: 1},{name:'policy',  path:'actions/get-policy.action', moduleName: 'checkout-terms-and-conditions',runOn: 1},{name:'product',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant', moduleName: 'buybox',runOn: 1},{name:'productSpecificationData',  path:'@msdyn365-commerce-modules/product-specification/dist/lib/dataActions/get-attributes-for-selected-variant', moduleName: 'buybox',runOn: 1},{name:'products',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-products-in-active-cart', moduleName: 'cart-icon',runOn: 0}],
        definitionExtensions: ['buybox','cart-icon','checkout-customer-account-payment','checkout-terms-and-conditions','content-block','footer-category','header','order-confirmation','order-details','product-specification','search-result-container'],
        iNM: false,
        ns: '__local__',
        n: 'fabrikam',
        p: '__local__',
        
        pdp: '',
        
        themeSettings: 'fabrikam.theme.settings.json',
        md: 'src/themes/fabrikam'
    });
        

    isNotRegistered('lds-account-management-address') && (binding.modules['lds-account-management-address'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-lds-account-management-address' */
            'partner/modules/lds-account-management-address/lds-account-management-address.tsx'),
        $type: 'contentModule',
        da: [{name:'address',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-address', runOn: 0},{name:'addressPurposes',  path:'@msdyn365-commerce-modules/address/dist/lib/actions/get-address-purposes', runOn: 0},{name:'countryRegions',  path:'@msdyn365-commerce-modules/address/dist/lib/actions/get-country-regions', runOn: 0},{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'lds-account-management-address',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/lds-account-management-address'
    });
        

    isNotRegistered('lds-buybox') && (binding.modules['lds-buybox'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-lds-buybox' */
            'partner/modules/lds-buybox/lds-buybox.tsx'),
        $type: 'containerModule',
        da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 0},{name:'cartDetails',  path:'actions/get-cart.action', runOn: 1},{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'deliveryOptions',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-selected-variant', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'orderTemplates',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/order-templates/get-order-templates-preview', runOn: 1},{name:'product',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant', runOn: 0},{name:'productAvailableQuantity',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-product-availabilities-for-selected-variant', runOn: 0},{name:'productDimensions',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-dimensions-for-selected-variant', runOn: 0},{name:'productPrice',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-price-for-selected-variant', runOn: 0},{name:'productSpecificationData',  path:'@msdyn365-commerce-modules/product-specification/dist/lib/dataActions/get-attributes-for-selected-variant', runOn: 1},{name:'ratingsSummary',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-ratings-summary', runOn: 1},{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 1},{name:'wishlists',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'lds-buybox',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/lds-buybox'
    });
        

    isNotRegistered('lds-cart') && (binding.modules['lds-cart'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-lds-cart' */
            'partner/modules/lds-cart/lds-cart.tsx'),
        $type: 'containerModule',
        da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 0},{name:'catalogs',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-catalogs', runOn: 0},{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'deliveryOptions',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'orderTemplates',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/order-templates/get-order-templates-preview', runOn: 1},{name:'orgUnitLocations',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations', runOn: 0},{name:'productAvailabilites',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-availabilities-cartlines', runOn: 0},{name:'products',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-products-in-active-cart', runOn: 0},{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 1},{name:'wishlistItems',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-items-in-wishlist', runOn: 1},{name:'wishlists',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'lds-cart',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/lds-cart'
    });
        

    isNotRegistered('lds-cart-icon') && (binding.modules['lds-cart-icon'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-lds-cart-icon' */
            'partner/modules/lds-cart-icon/lds-cart-icon.tsx'),
        $type: 'containerModule',
        da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/get-cart-state-data-action', runOn: 1},{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'orgUnitLocations',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'lds-cart-icon',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/lds-cart-icon'
    });
        

    isNotRegistered('lds-checkout') && (binding.modules['lds-checkout'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-lds-checkout' */
            'partner/modules/lds-checkout/lds-checkout.tsx'),
        $type: 'containerModule',
        da: [{name:'address',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-address', runOn: 0},{name:'addressPurposes',  path:'@msdyn365-commerce-modules/address/dist/lib/actions/get-address-purposes', runOn: 0},{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'churchRetailChannelCountry',  path:'actions/get-church-retail-channel-country.action', runOn: 0},{name:'countryRegions',  path:'@msdyn365-commerce-modules/address/dist/lib/actions/get-country-regions', runOn: 0},{name:'countryStates',  path:'@msdyn365-commerce-modules/address/dist/lib/actions/get-country-state', runOn: 0},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'customerSubscriptions',  path:'actions/get-customer-subscriptions.action', runOn: 1},{name:'deliveryOptions',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'orgUnitLocations',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations', runOn: 1},{name:'products',  path:'modules/lds-checkout/actions/get-products-in-active-checkout-cart', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'lds-checkout',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/lds-checkout'
    });
        

    isNotRegistered('lds-checkout-4') && (binding.modules['lds-checkout-4'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-lds-checkout-4' */
            'partner/modules/lds-checkout-4/lds-checkout-4.tsx'),
        $type: 'containerModule',
        da: [{name:'catalogs',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-catalogs', runOn: 0},{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'deliveryOptions',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines', runOn: 1},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'orgUnitLocations',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations', runOn: 1},{name:'products',  path:'modules/lds-checkout-4/actions/get-products-in-active-lds-checkout-4-cart', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'lds-checkout-4',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/lds-checkout-4'
    });
        

    isNotRegistered('lds-checkout-contact-4') && (binding.modules['lds-checkout-contact-4'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-lds-checkout-contact-4' */
            'partner/modules/lds-checkout-contact-4/lds-checkout-contact-4.tsx'),
        $type: 'contentModule',
        da: [{name:'accountInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 1},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'churchRetailChannelCountry',  path:'actions/get-church-retail-channel-country.action', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'lds-checkout-contact-4',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/lds-checkout-contact-4'
    });
        

    isNotRegistered('lds-checkout-contact-section') && (binding.modules['lds-checkout-contact-section'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-lds-checkout-contact-section' */
            'partner/modules/lds-checkout-contact-section/lds-checkout-contact-section.tsx'),
        $type: 'contentModule',
        da: [{name:'accountInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 1},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'churchRetailChannelCountry',  path:'actions/get-church-retail-channel-country.action', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'lds-checkout-contact-section',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/lds-checkout-contact-section'
    });
        

    isNotRegistered('lds-checkout-customer-account-payment') && (binding.modules['lds-checkout-customer-account-payment'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-lds-checkout-customer-account-payment' */
            'partner/modules/lds-customer-account-payment/lds-checkout-customer-account-payment.tsx'),
        $type: 'contentModule',
        da: [{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'creditBalances',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer-balance', runOn: 0},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'lds-checkout-customer-account-payment',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/lds-customer-account-payment'
    });
        

    isNotRegistered('lds-checkout-customer-account-payment-4') && (binding.modules['lds-checkout-customer-account-payment-4'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-lds-checkout-customer-account-payment-4' */
            'partner/modules/lds-checkout-customer-account-payment-4/lds-checkout-customer-account-payment-4.tsx'),
        $type: 'contentModule',
        da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 1},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'creditBalances',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer-balance', runOn: 0},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'lds-checkout-customer-account-payment-4',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/lds-checkout-customer-account-payment-4'
    });
        

    isNotRegistered('lds-checkout-delivery-options-4') && (binding.modules['lds-checkout-delivery-options-4'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-lds-checkout-delivery-options-4' */
            'partner/modules/lds-checkout-delivery-options-4/lds-checkout-delivery-options-4.tsx'),
        $type: 'contentModule',
        da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 0},{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'lds-checkout-delivery-options-4',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/lds-checkout-delivery-options-4'
    });
        

    isNotRegistered('lds-checkout-payment-instrument') && (binding.modules['lds-checkout-payment-instrument'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-lds-checkout-payment-instrument' */
            'partner/modules/lds-checkout-payment-instrument/lds-checkout-payment-instrument.tsx'),
        $type: 'contentModule',
        da: [{name:'cardPaymentAcceptPoint',  path:'modules/lds-checkout-payment-instrument/actions/get-card-payment-accept-point', runOn: 1},{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 1},{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'lds-checkout-payment-instrument',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/lds-checkout-payment-instrument'
    });
        

    isNotRegistered('lds-checkout-payment-instrument-2') && (binding.modules['lds-checkout-payment-instrument-2'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-lds-checkout-payment-instrument-2' */
            'partner/modules/lds-checkout-payment-instrument-2/lds-checkout-payment-instrument-2.tsx'),
        $type: 'contentModule',
        da: [{name:'cardPaymentAcceptPoint',  path:'modules/lds-checkout-payment-instrument-2/actions/get-card-payment-accept-point', runOn: 1},{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'lds-checkout-payment-instrument-2',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/lds-checkout-payment-instrument-2'
    });
        

    isNotRegistered('lds-checkout-pickup-4') && (binding.modules['lds-checkout-pickup-4'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-lds-checkout-pickup-4' */
            'partner/modules/lds-checkout-pickup-4/lds-checkout-pickup-4.tsx'),
        $type: 'contentModule',
        da: [{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'deliveryOptions',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'orgUnitLocations',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'lds-checkout-pickup-4',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/lds-checkout-pickup-4'
    });
        

    isNotRegistered('lds-checkout-section-container') && (binding.modules['lds-checkout-section-container'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-lds-checkout-section-container' */
            'partner/modules/lds-checkout-section-container/lds-checkout-section-container.tsx'),
        $type: 'containerModule',
        da: [{name:'cart',  path:'actions/get-cart.action', runOn: 1},{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'deliveryOptions',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines', runOn: 1},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'orgUnitLocations',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations', runOn: 1},{name:'paymentTypes',  path:'actions/get-payment-options.action', runOn: 1},{name:'policy',  path:'actions/get-policy.action', runOn: 1},{name:'products',  path:'modules/lds-checkout-section-container/actions/get-products-in-active-checkout-cart', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'lds-checkout-section-container',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/lds-checkout-section-container'
    });
        

    isNotRegistered('lds-checkout-section-container-4') && (binding.modules['lds-checkout-section-container-4'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-lds-checkout-section-container-4' */
            'partner/modules/lds-checkout-section-container-4/lds-checkout-section-container-4.tsx'),
        $type: 'containerModule',
        da: [{name:'cart',  path:'actions/get-cart.action', runOn: 1},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'paymentTypes',  path:'actions/get-payment-options.action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'lds-checkout-section-container-4',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/lds-checkout-section-container-4'
    });
        

    isNotRegistered('lds-checkout-shipping-address') && (binding.modules['lds-checkout-shipping-address'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-lds-checkout-shipping-address' */
            'partner/modules/lds-checkout-shipping-address/lds-checkout-shipping-address.tsx'),
        $type: 'contentModule',
        da: [{name:'address',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-address', runOn: 0},{name:'addressPurposes',  path:'@msdyn365-commerce-modules/address/dist/lib/actions/get-address-purposes', runOn: 0},{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'countryRegions',  path:'@msdyn365-commerce-modules/address/dist/lib/actions/get-country-regions', runOn: 0},{name:'countryStates',  path:'@msdyn365-commerce-modules/address/dist/lib/actions/get-country-state', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'lds-checkout-shipping-address',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/lds-checkout-shipping-address'
    });
        

    isNotRegistered('lds-checkout-shipping-address-4') && (binding.modules['lds-checkout-shipping-address-4'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-lds-checkout-shipping-address-4' */
            'partner/modules/lds-checkout-shipping-address-4/lds-checkout-shipping-address-4.tsx'),
        $type: 'contentModule',
        da: [{name:'address',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-address', runOn: 0},{name:'addressPurposes',  path:'@msdyn365-commerce-modules/address/dist/lib/actions/get-address-purposes', runOn: 0},{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 0},{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'countryRegions',  path:'@msdyn365-commerce-modules/address/dist/lib/actions/get-country-regions', runOn: 0},{name:'countryStates',  path:'@msdyn365-commerce-modules/address/dist/lib/actions/get-country-state', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'lds-checkout-shipping-address-4',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/lds-checkout-shipping-address-4'
    });
        

    isNotRegistered('lds-checkout-shipping-options') && (binding.modules['lds-checkout-shipping-options'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-lds-checkout-shipping-options' */
            'partner/modules/lds-checkout-shipping-options/lds-checkout-shipping-options.tsx'),
        $type: 'contentModule',
        da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 0},{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'deliveryOptions',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'lds-checkout-shipping-options',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/lds-checkout-shipping-options'
    });
        

    isNotRegistered('lds-checkout-terms-and-conditions') && (binding.modules['lds-checkout-terms-and-conditions'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-lds-checkout-terms-and-conditions' */
            'partner/modules/lds-checkout-terms-and-conditions/lds-checkout-terms-and-conditions.tsx'),
        $type: 'contentModule',
        da: [{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'policy',  path:'actions/get-policy.action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'lds-checkout-terms-and-conditions',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/lds-checkout-terms-and-conditions'
    });
        

    isNotRegistered('lds-checkout-terms-and-conditions-4') && (binding.modules['lds-checkout-terms-and-conditions-4'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-lds-checkout-terms-and-conditions-4' */
            'partner/modules/lds-checkout-terms-and-conditions-4/lds-checkout-terms-and-conditions-4.tsx'),
        $type: 'contentModule',
        da: [{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'policy',  path:'actions/get-policy.action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'lds-checkout-terms-and-conditions-4',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/lds-checkout-terms-and-conditions-4'
    });
        

    isNotRegistered('lds-contact') && (binding.modules['lds-contact'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-lds-contact' */
            'partner/modules/lds-contact/lds-contact.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'lds-contact',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/lds-contact'
    });
        

    isNotRegistered('lds-contact-us') && (binding.modules['lds-contact-us'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-lds-contact-us' */
            'partner/modules/lds-contact-us/lds-contact-us.tsx'),
        $type: 'contentModule',
        da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 0},{name:'countries',  path:'actions/get-country.action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'lds-contact-us',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/lds-contact-us'
    });
        

    isNotRegistered('lds-cookie-compliance') && (binding.modules['lds-cookie-compliance'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-lds-cookie-compliance' */
            'partner/modules/lds-cookie-compliance/lds-cookie-compliance.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'lds-cookie-compliance',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/lds-cookie-compliance'
    });
        

    isNotRegistered('lds-country-message') && (binding.modules['lds-country-message'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-lds-country-message' */
            'partner/modules/lds-country-message/lds-country-message.tsx'),
        $type: 'contentModule',
        da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'lds-country-message',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/lds-country-message'
    });
        

    isNotRegistered('lds-country-picker') && (binding.modules['lds-country-picker'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-lds-country-picker' */
            'partner/modules/lds-country-picker/lds-country-picker.tsx'),
        $type: 'contentModule',
        da: [{name:'countries',  path:'actions/get-country.action', runOn: 1},{name:'languages',  path:'actions/get-language.action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'lds-country-picker',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/lds-country-picker'
    });
        

    isNotRegistered('lds-currency-exchange-notice') && (binding.modules['lds-currency-exchange-notice'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-lds-currency-exchange-notice' */
            'partner/modules/lds-currency-exchange-notice/lds-currency-exchange-notice.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'lds-currency-exchange-notice',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/lds-currency-exchange-notice'
    });
        

    isNotRegistered('lds-customer-order-history') && (binding.modules['lds-customer-order-history'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-lds-customer-order-history' */
            'partner/modules/lds-customer-order-history/lds-customer-order-history.tsx'),
        $type: 'contentModule',
        da: [{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'channels',  path:'@msdyn365-commerce-modules/order-management/dist/lib/actions/get-channels', runOn: 0},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'orgUnitLocations',  path:'@msdyn365-commerce-modules/order-management/dist/lib/actions/get-org-unit-locations', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'lds-customer-order-history',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/lds-customer-order-history'
    });
        

    isNotRegistered('lds-delivery') && (binding.modules['lds-delivery'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-lds-delivery' */
            'partner/modules/lds-delivery/lds-delivery.tsx'),
        $type: 'contentModule',
        da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 0},{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'countryRegions',  path:'@msdyn365-commerce-modules/address/dist/lib/actions/get-country-regions', runOn: 0},{name:'countryStates',  path:'@msdyn365-commerce-modules/address/dist/lib/actions/get-country-state', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'orgUnitLocations',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations', runOn: 1},{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'lds-delivery',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/lds-delivery'
    });
        

    isNotRegistered('lds-error') && (binding.modules['lds-error'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-lds-error' */
            'partner/modules/lds-error/lds-error.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'lds-error',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/lds-error'
    });
        

    isNotRegistered('lds-find-store') && (binding.modules['lds-find-store'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-lds-find-store' */
            'partner/modules/lds-find-store/lds-find-store.tsx'),
        $type: 'containerModule',
        da: [{name:'availabilitiesWithHours',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-full-available-inventory-nearby', runOn: 1},{name:'cartDetails',  path:'actions/get-cart.action', runOn: 1},{name:'storeLocations',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-store-location-information', runOn: 1},{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'lds-find-store',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/lds-find-store'
    });
        

    isNotRegistered('lds-footer') && (binding.modules['lds-footer'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-lds-footer' */
            'partner/modules/lds-footer/lds-footer.tsx'),
        $type: 'contentModule',
        da: [{name:'policy',  path:'actions/get-policy.action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'lds-footer',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/lds-footer'
    });
        

    isNotRegistered('lds-header') && (binding.modules['lds-header'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-lds-header' */
            'partner/modules/lds-header/lds-header.tsx'),
        $type: 'containerModule',
        da: [{name:'accountInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/get-cart-state-data-action', runOn: 1},{name:'countries',  path:'actions/get-country.action', runOn: 1},{name:'languages',  path:'actions/get-language.action', runOn: 1},{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 1},{name:'wishlists',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'lds-header',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/lds-header'
    });
        

    isNotRegistered('lds-info') && (binding.modules['lds-info'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-lds-info' */
            'partner/modules/lds-info/lds-info.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'lds-info',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/lds-info'
    });
        

    isNotRegistered('lds-my-subscriptions') && (binding.modules['lds-my-subscriptions'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-lds-my-subscriptions' */
            'partner/modules/lds-my-subscriptions/lds-my-subscriptions.tsx'),
        $type: 'contentModule',
        da: [{name:'accountInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'address',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-address', runOn: 0},{name:'addressPurposes',  path:'@msdyn365-commerce-modules/address/dist/lib/actions/get-address-purposes', runOn: 0},{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 0},{name:'countryRegions',  path:'@msdyn365-commerce-modules/address/dist/lib/actions/get-country-regions', runOn: 0},{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'lds-my-subscriptions',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/lds-my-subscriptions'
    });
        

    isNotRegistered('lds-order-history') && (binding.modules['lds-order-history'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-lds-order-history' */
            'partner/modules/lds-order-history/lds-order-history.tsx'),
        $type: 'contentModule',
        da: [{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'channels',  path:'@msdyn365-commerce-modules/order-management/dist/lib/actions/get-channels', runOn: 0},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'orgUnitLocations',  path:'@msdyn365-commerce-modules/order-management/dist/lib/actions/get-org-unit-locations', runOn: 0},{name:'paymentTypes',  path:'actions/get-payment-options.action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'lds-order-history',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/lds-order-history'
    });
        

    isNotRegistered('lds-shipping') && (binding.modules['lds-shipping'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-lds-shipping' */
            'partner/modules/lds-shipping/lds-shipping.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'lds-shipping',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/lds-shipping'
    });
        

    isNotRegistered('lds-staples-message') && (binding.modules['lds-staples-message'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-lds-staples-message' */
            'partner/modules/lds-staples-message/lds-staples-message.tsx'),
        $type: 'contentModule',
        da: [{name:'paymentTypes',  path:'actions/get-payment-options.action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'lds-staples-message',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/lds-staples-message'
    });
        

    isNotRegistered('lds-store-locator') && (binding.modules['lds-store-locator'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-lds-store-locator' */
            'partner/modules/lds-store-locator/lds-store-locator.tsx'),
        $type: 'containerModule',
        da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 0},{name:'countries',  path:'actions/get-country.action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'lds-store-locator',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/lds-store-locator'
    });
        

    isNotRegistered('lds-subscription-checkout') && (binding.modules['lds-subscription-checkout'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-lds-subscription-checkout' */
            'partner/modules/lds-subscription-checkout/lds-subscription-checkout.tsx'),
        $type: 'contentModule',
        da: [{name:'address',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-address', runOn: 0},{name:'addressPurposes',  path:'@msdyn365-commerce-modules/address/dist/lib/actions/get-address-purposes', runOn: 0},{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'countryRegions',  path:'@msdyn365-commerce-modules/address/dist/lib/actions/get-country-regions', runOn: 0},{name:'countryStates',  path:'@msdyn365-commerce-modules/address/dist/lib/actions/get-country-state', runOn: 0},{name:'deliveryOptions',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'orgUnitLocations',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations', runOn: 1},{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'lds-subscription-checkout',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/lds-subscription-checkout'
    });
        

    isNotRegistered('lds-terms-and-conditions') && (binding.modules['lds-terms-and-conditions'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-lds-terms-and-conditions' */
            'partner/modules/lds-terms-and-conditions/lds-terms-and-conditions.tsx'),
        $type: 'contentModule',
        da: [{name:'policy',  path:'actions/get-policy.action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'lds-terms-and-conditions',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/lds-terms-and-conditions'
    });
        

    isNotRegistered('lds-unit-history-tile') && (binding.modules['lds-unit-history-tile'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-lds-unit-history-tile' */
            'partner/modules/lds-unit-history-tile/lds-unit-history-tile.tsx'),
        $type: 'contentModule',
        da: [{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'paymentTypes',  path:'actions/get-payment-options.action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'lds-unit-history-tile',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/lds-unit-history-tile'
    });
        

    isNotRegistered('lds-warn') && (binding.modules['lds-warn'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-lds-warn' */
            'partner/modules/lds-warn/lds-warn.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'lds-warn',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/lds-warn'
    });
        

    isNotRegistered('media-links') && (binding.modules['media-links'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-media-links' */
            'partner/modules/media-links/media-links.tsx'),
        $type: 'contentModule',
        da: [{name:'product',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant', runOn: 1},{name:'productSpecificationData',  path:'@msdyn365-commerce-modules/product-specification/dist/lib/dataActions/get-attributes-for-selected-variant', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'media-links',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/media-links'
    });
        

    isNotRegistered('my-script-injector') && (binding.modules['my-script-injector'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-my-script-injector' */
            'partner/modules/my-script-injector/my-script-injector.tsx'),
        $type: 'scriptModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'my-script-injector',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/my-script-injector'
    });
        

    isNotRegistered('product-page-summary') && (binding.modules['product-page-summary'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-product-page-summary' */
            'partner/modules/lds-product-page-summary/product-page-summary.tsx'),
        $type: 'htmlHeadTagsModule',
        da: [{name:'countries',  path:'actions/get-country.action', runOn: 0},{name:'productPageSummary',  path:'modules/lds-product-page-summary/product-page-summary.action', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'product-page-summary',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/lds-product-page-summary'
    });
        

        {   
            const actionPath = 'actions/base-collection.action';
            binding.dataActions[actionPath] = require('partner/actions/base-collection.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/custom-get-full-products-by-collection.action';
            binding.dataActions[actionPath] = require('partner/actions/custom-get-full-products-by-collection.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-auto-suggest-suggestions.action';
            binding.dataActions[actionPath] = require('partner/actions/get-auto-suggest-suggestions.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-cart.action';
            binding.dataActions[actionPath] = require('partner/actions/get-cart.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-church-retail-channel-country.action';
            binding.dataActions[actionPath] = require('partner/actions/get-church-retail-channel-country.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-country.action';
            binding.dataActions[actionPath] = require('partner/actions/get-country.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-customer-subscriptions.action';
            binding.dataActions[actionPath] = require('partner/actions/get-customer-subscriptions.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-full-products-by-collection.action';
            binding.dataActions[actionPath] = require('partner/actions/get-full-products-by-collection.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-language.action';
            binding.dataActions[actionPath] = require('partner/actions/get-language.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-payment-options.action';
            binding.dataActions[actionPath] = require('partner/actions/get-payment-options.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-policy.action';
            binding.dataActions[actionPath] = require('partner/actions/get-policy.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/list-page-state.action';
            binding.dataActions[actionPath] = require('partner/actions/list-page-state.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'modules/lds-category-page-summary/category-page-summary.action';
            binding.dataActions[actionPath] = require('partner/modules/lds-category-page-summary/category-page-summary.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'modules/lds-default-summary/default-page-summary.action';
            binding.dataActions[actionPath] = require('partner/modules/lds-default-summary/default-page-summary.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'modules/lds-product-page-summary/product-page-summary.action';
            binding.dataActions[actionPath] = require('partner/modules/lds-product-page-summary/product-page-summary.action');
            registerActionId(actionPath);
        }

        if (isNotRegistered('default-page-summary')){
            const sanitizedActionPath = 'actions/get-country.action';
            let dataAction = require('partner/actions/get-country.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('default-page-summary')){
            const sanitizedActionPath = 'modules/lds-default-summary/default-page-summary.action';
            let dataAction = require('partner/modules/lds-default-summary/default-page-summary.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('fabrikam')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/product-specification/dist/lib/dataActions/get-attributes-for-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/product-specification/dist/lib/dataActions/get-attributes-for-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('fabrikam')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-products-in-active-cart';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-products-in-active-cart');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('fabrikam')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('fabrikam')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('fabrikam')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('fabrikam')){
            const sanitizedActionPath = 'actions/get-country.action';
            let dataAction = require('partner/actions/get-country.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('fabrikam')){
            const sanitizedActionPath = 'actions/get-language.action';
            let dataAction = require('partner/actions/get-language.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('fabrikam')){
            const sanitizedActionPath = 'actions/get-policy.action';
            let dataAction = require('partner/actions/get-policy.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('fabrikam')){
            const sanitizedActionPath = 'actions/get-policy.action';
            let dataAction = require('partner/actions/get-policy.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-account-management-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/address/dist/lib/actions/get-address-purposes';
            let dataAction = require('@msdyn365-commerce-modules/address/dist/lib/actions/get-address-purposes');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-account-management-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/address/dist/lib/actions/get-country-regions';
            let dataAction = require('@msdyn365-commerce-modules/address/dist/lib/actions/get-country-regions');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-account-management-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            let dataAction = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-account-management-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-address';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-address');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-buybox')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            let dataAction = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-buybox')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/product-specification/dist/lib/dataActions/get-attributes-for-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/product-specification/dist/lib/dataActions/get-attributes-for-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-buybox')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-buybox')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-buybox')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-buybox')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-dimensions-for-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-dimensions-for-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-buybox')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-buybox')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-price-for-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-price-for-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-buybox')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-product-availabilities-for-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-product-availabilities-for-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-buybox')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-ratings-summary';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-ratings-summary');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-buybox')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-buybox')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-buybox')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/order-templates/get-order-templates-preview';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/order-templates/get-order-templates-preview');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-buybox')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-buybox')){
            const sanitizedActionPath = 'actions/get-cart.action';
            let dataAction = require('partner/actions/get-cart.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-cart')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            let dataAction = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-cart')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-availabilities-cartlines';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-availabilities-cartlines');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-cart')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-catalogs';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-catalogs');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-cart')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-cart')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-cart')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-cart')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-cart')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-items-in-wishlist';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-items-in-wishlist');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-cart')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-products-in-active-cart';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-products-in-active-cart');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-cart')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-cart')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/order-templates/get-order-templates-preview';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/order-templates/get-order-templates-preview');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-cart')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-cart')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-cart-icon')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-cart-icon')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-cart-icon')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-cart-icon')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-cart-icon')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/get-cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/get-cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/address/dist/lib/actions/get-address-purposes';
            let dataAction = require('@msdyn365-commerce-modules/address/dist/lib/actions/get-address-purposes');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/address/dist/lib/actions/get-country-regions';
            let dataAction = require('@msdyn365-commerce-modules/address/dist/lib/actions/get-country-regions');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/address/dist/lib/actions/get-country-state';
            let dataAction = require('@msdyn365-commerce-modules/address/dist/lib/actions/get-country-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-address';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-address');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout')){
            const sanitizedActionPath = 'actions/get-church-retail-channel-country.action';
            let dataAction = require('partner/actions/get-church-retail-channel-country.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout')){
            const sanitizedActionPath = 'actions/get-customer-subscriptions.action';
            let dataAction = require('partner/actions/get-customer-subscriptions.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout')){
            const sanitizedActionPath = 'modules/lds-checkout/actions/get-products-in-active-checkout-cart';
            let dataAction = require('partner/modules/lds-checkout/actions/get-products-in-active-checkout-cart');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-4')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-catalogs';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-catalogs');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-4')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-4')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-4')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-4')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-4')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-4')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-4')){
            const sanitizedActionPath = 'modules/lds-checkout-4/actions/get-products-in-active-lds-checkout-4-cart';
            let dataAction = require('partner/modules/lds-checkout-4/actions/get-products-in-active-lds-checkout-4-cart');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-contact-4')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-contact-4')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-contact-4')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-contact-4')){
            const sanitizedActionPath = 'actions/get-church-retail-channel-country.action';
            let dataAction = require('partner/actions/get-church-retail-channel-country.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-contact-section')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-contact-section')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-contact-section')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-contact-section')){
            const sanitizedActionPath = 'actions/get-church-retail-channel-country.action';
            let dataAction = require('partner/actions/get-church-retail-channel-country.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-customer-account-payment')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-customer-account-payment')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer-balance';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer-balance');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-customer-account-payment')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-customer-account-payment-4')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-customer-account-payment-4')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer-balance';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer-balance');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-customer-account-payment-4')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-customer-account-payment-4')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-delivery-options-4')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-delivery-options-4')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-delivery-options-4')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-delivery-options-4')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-payment-instrument')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-payment-instrument')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-payment-instrument')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-payment-instrument')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-payment-instrument')){
            const sanitizedActionPath = 'modules/lds-checkout-payment-instrument/actions/get-card-payment-accept-point';
            let dataAction = require('partner/modules/lds-checkout-payment-instrument/actions/get-card-payment-accept-point');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-payment-instrument-2')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-payment-instrument-2')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-payment-instrument-2')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-payment-instrument-2')){
            const sanitizedActionPath = 'modules/lds-checkout-payment-instrument-2/actions/get-card-payment-accept-point';
            let dataAction = require('partner/modules/lds-checkout-payment-instrument-2/actions/get-card-payment-accept-point');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-pickup-4')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-pickup-4')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-pickup-4')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-pickup-4')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-pickup-4')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-section-container')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-section-container')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-section-container')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-section-container')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-section-container')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-section-container')){
            const sanitizedActionPath = 'actions/get-cart.action';
            let dataAction = require('partner/actions/get-cart.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-section-container')){
            const sanitizedActionPath = 'actions/get-payment-options.action';
            let dataAction = require('partner/actions/get-payment-options.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-section-container')){
            const sanitizedActionPath = 'actions/get-policy.action';
            let dataAction = require('partner/actions/get-policy.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-section-container')){
            const sanitizedActionPath = 'modules/lds-checkout-section-container/actions/get-products-in-active-checkout-cart';
            let dataAction = require('partner/modules/lds-checkout-section-container/actions/get-products-in-active-checkout-cart');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-section-container-4')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-section-container-4')){
            const sanitizedActionPath = 'actions/get-cart.action';
            let dataAction = require('partner/actions/get-cart.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-section-container-4')){
            const sanitizedActionPath = 'actions/get-payment-options.action';
            let dataAction = require('partner/actions/get-payment-options.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-shipping-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/address/dist/lib/actions/get-address-purposes';
            let dataAction = require('@msdyn365-commerce-modules/address/dist/lib/actions/get-address-purposes');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-shipping-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/address/dist/lib/actions/get-country-regions';
            let dataAction = require('@msdyn365-commerce-modules/address/dist/lib/actions/get-country-regions');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-shipping-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/address/dist/lib/actions/get-country-state';
            let dataAction = require('@msdyn365-commerce-modules/address/dist/lib/actions/get-country-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-shipping-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            let dataAction = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-shipping-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-address';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-address');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-shipping-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-shipping-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-shipping-address')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-shipping-address-4')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/address/dist/lib/actions/get-address-purposes';
            let dataAction = require('@msdyn365-commerce-modules/address/dist/lib/actions/get-address-purposes');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-shipping-address-4')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/address/dist/lib/actions/get-country-regions';
            let dataAction = require('@msdyn365-commerce-modules/address/dist/lib/actions/get-country-regions');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-shipping-address-4')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/address/dist/lib/actions/get-country-state';
            let dataAction = require('@msdyn365-commerce-modules/address/dist/lib/actions/get-country-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-shipping-address-4')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            let dataAction = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-shipping-address-4')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-address';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-address');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-shipping-address-4')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-shipping-address-4')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-shipping-address-4')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-shipping-address-4')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-shipping-options')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-shipping-options')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-shipping-options')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-shipping-options')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-shipping-options')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-terms-and-conditions')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-terms-and-conditions')){
            const sanitizedActionPath = 'actions/get-policy.action';
            let dataAction = require('partner/actions/get-policy.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-terms-and-conditions-4')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-checkout-terms-and-conditions-4')){
            const sanitizedActionPath = 'actions/get-policy.action';
            let dataAction = require('partner/actions/get-policy.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-contact-us')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-contact-us')){
            const sanitizedActionPath = 'actions/get-country.action';
            let dataAction = require('partner/actions/get-country.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-country-message')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-country-picker')){
            const sanitizedActionPath = 'actions/get-country.action';
            let dataAction = require('partner/actions/get-country.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-country-picker')){
            const sanitizedActionPath = 'actions/get-language.action';
            let dataAction = require('partner/actions/get-language.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-customer-order-history')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/order-management/dist/lib/actions/get-channels';
            let dataAction = require('@msdyn365-commerce-modules/order-management/dist/lib/actions/get-channels');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-customer-order-history')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/order-management/dist/lib/actions/get-org-unit-locations';
            let dataAction = require('@msdyn365-commerce-modules/order-management/dist/lib/actions/get-org-unit-locations');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-customer-order-history')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-customer-order-history')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-customer-order-history')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-delivery')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/address/dist/lib/actions/get-country-regions';
            let dataAction = require('@msdyn365-commerce-modules/address/dist/lib/actions/get-country-regions');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-delivery')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/address/dist/lib/actions/get-country-state';
            let dataAction = require('@msdyn365-commerce-modules/address/dist/lib/actions/get-country-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-delivery')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            let dataAction = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-delivery')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-delivery')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-delivery')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-delivery')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-find-store')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            let dataAction = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-find-store')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-full-available-inventory-nearby';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-full-available-inventory-nearby');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-find-store')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-store-location-information';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-store-location-information');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-find-store')){
            const sanitizedActionPath = 'actions/get-cart.action';
            let dataAction = require('partner/actions/get-cart.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-footer')){
            const sanitizedActionPath = 'actions/get-policy.action';
            let dataAction = require('partner/actions/get-policy.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-header')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            let dataAction = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-header')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-header')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-header')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/get-cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/get-cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-header')){
            const sanitizedActionPath = 'actions/get-country.action';
            let dataAction = require('partner/actions/get-country.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-header')){
            const sanitizedActionPath = 'actions/get-language.action';
            let dataAction = require('partner/actions/get-language.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-my-subscriptions')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/address/dist/lib/actions/get-address-purposes';
            let dataAction = require('@msdyn365-commerce-modules/address/dist/lib/actions/get-address-purposes');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-my-subscriptions')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/address/dist/lib/actions/get-country-regions';
            let dataAction = require('@msdyn365-commerce-modules/address/dist/lib/actions/get-country-regions');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-my-subscriptions')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            let dataAction = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-my-subscriptions')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-address';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-address');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-my-subscriptions')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-my-subscriptions')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-order-history')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/order-management/dist/lib/actions/get-channels';
            let dataAction = require('@msdyn365-commerce-modules/order-management/dist/lib/actions/get-channels');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-order-history')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/order-management/dist/lib/actions/get-org-unit-locations';
            let dataAction = require('@msdyn365-commerce-modules/order-management/dist/lib/actions/get-org-unit-locations');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-order-history')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-order-history')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-order-history')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-order-history')){
            const sanitizedActionPath = 'actions/get-payment-options.action';
            let dataAction = require('partner/actions/get-payment-options.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-staples-message')){
            const sanitizedActionPath = 'actions/get-payment-options.action';
            let dataAction = require('partner/actions/get-payment-options.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-store-locator')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-store-locator')){
            const sanitizedActionPath = 'actions/get-country.action';
            let dataAction = require('partner/actions/get-country.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-subscription-checkout')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/address/dist/lib/actions/get-address-purposes';
            let dataAction = require('@msdyn365-commerce-modules/address/dist/lib/actions/get-address-purposes');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-subscription-checkout')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/address/dist/lib/actions/get-country-regions';
            let dataAction = require('@msdyn365-commerce-modules/address/dist/lib/actions/get-country-regions');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-subscription-checkout')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/address/dist/lib/actions/get-country-state';
            let dataAction = require('@msdyn365-commerce-modules/address/dist/lib/actions/get-country-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-subscription-checkout')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            let dataAction = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-subscription-checkout')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-address';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-address');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-subscription-checkout')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-subscription-checkout')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-subscription-checkout')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-subscription-checkout')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-subscription-checkout')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-terms-and-conditions')){
            const sanitizedActionPath = 'actions/get-policy.action';
            let dataAction = require('partner/actions/get-policy.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-unit-history-tile')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lds-unit-history-tile')){
            const sanitizedActionPath = 'actions/get-payment-options.action';
            let dataAction = require('partner/actions/get-payment-options.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('media-links')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/product-specification/dist/lib/dataActions/get-attributes-for-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/product-specification/dist/lib/dataActions/get-attributes-for-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('media-links')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('product-page-summary')){
            const sanitizedActionPath = 'actions/get-country.action';
            let dataAction = require('partner/actions/get-country.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('product-page-summary')){
            const sanitizedActionPath = 'modules/lds-product-page-summary/product-page-summary.action';
            let dataAction = require('partner/modules/lds-product-page-summary/product-page-summary.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

    
    } catch (e) {
        handleError('-', e);
    }
    
    return binding;
};